module.exports = __webpack_public_path__ + "static/media/HOME-image2.697d8da6.png";